// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.cltv-dashboard-layout {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.cltv-dashboard {
  width: 100%;
  margin: 0 auto;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
}

.cltv-dashboard__main {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: visible;
  -webkit-overflow-scrolling: touch;
}

.cltv-dashboard input,
.cltv-dashboard button {
  font-family: "Open Sans", sans-serif;
}

.cltv-dashboard button {
  text-transform: uppercase;
}

.cltv-dashboard__top {
  flex-shrink: 0;
  margin-bottom: 8px;
}

.cltv-dashboard__main .dashboard-narrative-panel {
  margin-bottom: 14px;
}
.cltv-dashboard__main .dashboard-narrative-panel button {
  text-transform: none;
}

.cltv-dashboard__kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}

.cltv-dashboard__kpi-loading {
  grid-column: 1/-1;
  display: flex;
  justify-content: center;
  padding: 24px;
}

.cltv-dashboard__error-banner {
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(180, 60, 60, 0.35);
  background: rgba(180, 60, 60, 0.08);
  color: #000000;
  font-size: 12px;
}

.cltv-dashboard__empty {
  margin: 16px 0;
  color: #000000;
  font-size: 12px;
}

.cltv-dashboard__kpi-card,
.cltv-dashboard__panel {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.cltv-dashboard__kpi-card {
  padding: 18px 20px;
}

.cltv-dashboard__kpi-card .dashboard-kpi-card__title {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  max-height: none;
  -webkit-line-clamp: unset;
  line-clamp: unset;
}

.cltv-dashboard__kpi-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  min-width: 0;
}

.cltv-dashboard__kpi-title-text {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 0 1 auto;
}

.cltv-dashboard__badge {
  display: inline-flex;
  align-items: center;
  border-radius: 18px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(44, 104, 173, 0.18);
  border: 1px solid rgb(44, 104, 173);
  color: #2c68ad;
  display: inline-flex;
  align-items: center;
  align-self: center;
  white-space: nowrap;
  line-height: 1.2;
}

.cltv-dashboard__kpi-card .dashboard-kpi-card__description {
  margin-top: 0;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
}

.cltv-dashboard__kpi-card .dashboard-kpi-card__footer {
  margin-top: -4px;
}

.cltv-dashboard__kpi-card strong {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
}

.cltv-dashboard__trend-up {
  color: #0f9f60;
}

.cltv-dashboard__trend-down {
  color: #d92d20;
}

.cltv-dashboard__dual {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 14px;
  align-items: stretch;
}
.cltv-dashboard__dual > article {
  height: 100%;
  margin-bottom: 0;
}

.cltv-dashboard__panel {
  padding: 18px;
  margin-bottom: 14px;
  overflow: visible;
}

.cltv-dashboard__panel--segment-distribution {
  display: flex;
  flex-direction: column;
}

.cltv-dashboard__panel--customer-analytics {
  padding: 0;
  overflow: hidden;
}

.cltv-dashboard__panel h3 {
  margin: 0 0 14px;
  color: #101828;
  font-size: 18px;
  font-weight: 700;
}

.cltv-dashboard__title-with-tooltip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
}

.cltv-dashboard__title-with-tooltip .definition-tooltip {
  flex-shrink: 0;
}

.cltv-dashboard__title-with-tooltip h3 {
  margin-bottom: 0;
}

.cltv-dashboard__title-with-tooltip--table {
  margin-bottom: 0;
  margin-top: 0;
}

.cltv-dashboard__kpi-card,
.cltv-dashboard__kpi-card .dashboard-kpi-card,
.cltv-dashboard__kpi-card .dashboard-kpi-card__header,
.cltv-dashboard__kpi-card .dashboard-kpi-card__header-main,
.cltv-dashboard__kpi-card .dashboard-kpi-card__title-row {
  overflow: visible;
}

.cltv-dashboard__segment-chart-wrap {
  margin-top: 8px;
  flex: 1 1 auto;
  display: flex;
}

.cltv-dashboard__hbar-chart {
  display: flex;
  flex-direction: column;
  gap: 40px;
  flex: 1 1 auto;
  padding: 15px;
}

.cltv-dashboard__hbar-row {
  display: grid;
  grid-template-columns: 110px 1fr 56px;
  align-items: center;
  gap: 10px;
}

.cltv-dashboard__hbar-row-head {
  display: contents;
}

.cltv-dashboard__hbar-label {
  font-size: 12px;
  font-weight: 500;
  color: #344054;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cltv-dashboard__hbar-track {
  width: 100%;
  height: 18px;
  background: #f1f4f8;
  border-radius: 4px;
  overflow: hidden;
  min-width: 0;
}

.cltv-dashboard__hbar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.4s ease;
}

.cltv-dashboard__hbar-value {
  font-size: 12px;
  font-weight: 600;
  color: #344054;
  text-align: end;
  white-space: nowrap;
}

.cltv-dashboard__insights {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.cltv-dashboard__pi-revenue {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 14px;
  border-bottom: 1px solid #eeeeee;
}

.cltv-dashboard__pi-revenue-label {
  margin: 0;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7280;
}

.cltv-dashboard__pi-revenue-value {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.15;
}

.cltv-dashboard__pi-revenue-desc {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
}

.cltv-dashboard__pi-risk {
  padding-top: 14px;
  padding-bottom: 14px;
}

.cltv-dashboard__pi-risk-title {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}

.cltv-dashboard__pi-tiers {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cltv-dashboard__pi-tier-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.cltv-dashboard__pi-tier-name {
  font-size: 12px;
  color: #6b7280;
}

.cltv-dashboard__pi-tier-count {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a1a;
}

.cltv-dashboard__pi-tier .cltv-dashboard__progress {
  margin-top: 4px;
  height: 6px;
}

.cltv-dashboard__pi-churn-alert {
  padding: 12px 14px;
  border-radius: 8px;
  background: rgba(224, 82, 82, 0.08);
  border: 1px solid rgba(224, 82, 82, 0.2);
}

.cltv-dashboard__pi-churn-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.cltv-dashboard__pi-churn-icon {
  display: flex;
  align-items: center;
  color: #e05252;
  flex-shrink: 0;
}

.cltv-dashboard__pi-churn-label {
  flex: 1 1;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #e05252;
}

.cltv-dashboard__pi-churn-badge {
  padding: 4px 12px;
  border-radius: 4px;
  background: #e05252;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
}

.cltv-dashboard__pi-churn-count {
  margin: 0 0 4px;
  padding-inline-start: 24px;
  font-size: 14px;
  font-weight: 700;
  color: #e05252;
}

.cltv-dashboard__pi-churn-desc {
  margin: 0;
  padding-inline-start: 24px;
  font-size: 12px;
  color: #e05252;
  line-height: 1.5;
}

.cltv-dashboard__insight-head {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
}

.cltv-dashboard__insight-left {
  display: flex;
  gap: 10px;
}

.cltv-dashboard__insight-icon {
  margin-top: 4px;
  font-size: 16px;
}

.cltv-dashboard__insight-icon--positive {
  color: #94d0b5;
}

.cltv-dashboard__insight-icon--warning {
  color: #f6c15f;
}

.cltv-dashboard__insight-icon--info {
  color: #8d4fd3;
}

.cltv-dashboard__insight-left h4 {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.cltv-dashboard__insight-title-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.cltv-dashboard__insight-title-row h4 {
  margin-bottom: 0;
}

.cltv-dashboard__insight-left p {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
}

.cltv-dashboard__insight-right {
  text-align: end;
}

.cltv-dashboard__insight-right strong {
  display: block;
  font-size: 16px;
}

.cltv-dashboard__insight-right span {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 8px;
  border-radius: 8px;
  border: 1px solid rgb(44, 104, 173);
  font-size: 12px;
  color: #2c68ad;
  background: rgba(44, 104, 173, 0.18);
}

.cltv-dashboard__progress {
  margin-top: 10px;
  height: 10px;
  border-radius: 12px;
  background: #eeeeee;
  overflow: hidden;
}

.cltv-dashboard__progress span {
  display: block;
  height: 100%;
  border-radius: 12px;
  background: #2b74e4;
}

.cltv-dashboard__chart {
  width: 100%;
  height: auto;
  position: relative;
  overflow: visible;
}

.cltv-dashboard__chart .recharts-wrapper,
.cltv-dashboard__chart .recharts-surface {
  overflow: visible;
}

/**
 * Segment Evolution + Actual vs Predicted Revenue: Recharts positions hover coordinates
 * in an LTR system. In Arabic the wrapper inherits \`dir="rtl"\`, which skews
 * \`activeCoordinate\` and sends the portalled tooltip to the viewport's far edge.
 */
.cltv-dashboard__panel--spending .cltv-dashboard__chart .recharts-wrapper,
.cltv-dashboard__panel--evolution .cltv-dashboard__chart .recharts-wrapper {
  direction: ltr;
}

.cltv-dashboard__panel--spending .cltv-dashboard__chart .recharts-surface,
.cltv-dashboard__panel--evolution .cltv-dashboard__chart .recharts-surface {
  direction: ltr;
}

.cltv-dashboard__floating-tooltip {
  position: fixed;
  left: 0;
  top: 0;
  width: max-content;
  max-width: min(420px, 100vw - 16px);
  visibility: hidden;
  pointer-events: none;
  z-index: 5000;
}

.cltv-dashboard__floating-tooltip--placed {
  visibility: visible;
}

.cltv-dashboard__floating-tooltip--chart-panel {
  direction: ltr;
}

[dir=rtl] .cltv-dashboard__floating-tooltip--chart-panel .analytics-chart-tooltip {
  direction: rtl;
}

[dir=rtl] .cltv-dashboard__floating-tooltip--spending-panel {
  direction: ltr;
}

[dir=rtl] .cltv-dashboard__floating-tooltip--spending-panel .analytics-chart-tooltip {
  direction: rtl;
}

.cltv-dashboard__chart-subtitle {
  flex: 0 0 100%;
  margin: 2px 0 0;
  color: #587194;
  font-size: 13px;
  font-weight: 500;
}

.cltv-dashboard__panel-note {
  flex: 0 0 100%;
  padding: 0;
  border-radius: 6px;
  color: #587194;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.cltv-dashboard__panel--spending {
  padding-bottom: 8px;
  overflow: visible;
}

.cltv-dashboard__spending-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.cltv-dashboard .recharts-cartesian-axis-line,
.cltv-dashboard .recharts-cartesian-axis-tick-line {
  stroke: transparent;
}

.cltv-dashboard .recharts-cartesian-grid line {
  stroke: #e8eef8;
}

.cltv-dashboard .recharts-text {
  fill: #587194;
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
}

.cltv-dashboard .recharts-reference-line line {
  stroke-width: 2px;
}

.cltv-dashboard__panel--evolution {
  padding-bottom: 8px;
  overflow: visible;
}

.cltv-dashboard__evolution-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.cltv-dashboard__line-legend {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: flex-end;
  font-size: 12px;
  font-weight: 500;
  color: #344054;
  flex-shrink: 0;
}

.cltv-dashboard__line-legend span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #344054;
}

.cltv-dashboard__line-legend i {
  width: 10px;
  height: 10px;
  border-radius: 10%;
  display: inline-block;
  flex-shrink: 0;
}

/* ── Customer Analytics Table card ───────────────────────────────────── */
.cltv-dashboard__panel--customer-analytics {
  padding: 0;
  overflow: hidden;
}

.cltv-dashboard__customer-analytics {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
  overflow: visible;
}

/* Toolbar ── title left, controls right, single row */
.cltv-dashboard__table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  padding: 20px 24px;
}

.cltv-dashboard__table-toolbar-left {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.cltv-dashboard__data-table-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #101828;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.cltv-dashboard__table-controls {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  margin-bottom: 0;
}
.cltv-dashboard__table-controls .filter-dropdown {
  min-width: 180px;
  margin: 0 !important;
}
.cltv-dashboard__table-controls .filter-dropdown .ant-select-selector {
  height: 42px !important;
  width: 320px;
  min-height: 42px !important;
  border-radius: 6px !important;
  padding: 0 40px 0 12px !important;
  display: flex !important;
  align-items: center !important;
}
.cltv-dashboard__table-controls .filter-dropdown .ant-select-selection-overflow {
  display: flex !important;
  flex-wrap: nowrap;
  overflow: hidden;
  align-items: center !important;
  height: 100% !important;
  gap: 4px;
  margin: 0 !important;
}
.cltv-dashboard__table-controls .filter-dropdown .ant-select-selection-overflow-item {
  flex: 0 0 auto !important;
  align-self: center !important;
  margin: 0 !important;
}
.cltv-dashboard__table-controls .filter-dropdown .ant-select-selection-item {
  margin: 0 !important;
  height: 28px !important;
  line-height: 28px !important;
  border-radius: 4px !important;
  font-size: 13px !important;
  flex: 0 0 auto !important;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex !important;
  align-items: center !important;
}
.cltv-dashboard__table-controls .filter-dropdown .ant-select-arrow {
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin-top: 0;
}

/* Search input */
.cltv-dashboard__table-search {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 14px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  cursor: text;
  color: #98a2b3;
}
.cltv-dashboard__table-search input {
  border: 0;
  outline: none;
  background: transparent;
  width: 300px;
  font-size: 13px;
  color: #344054;
  font-family: "Open Sans", sans-serif;
}
.cltv-dashboard__table-search input::placeholder {
  color: #98a2b3;
}

.cltv-dashboard__table-search-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #667085;
  cursor: pointer;
  flex-shrink: 0;
}
.cltv-dashboard__table-search-clear:hover {
  color: #344054;
}

/* Segment pill filter buttons — each is a standalone pill, no connected borders */
.cltv-dashboard__segment-pills {
  display: flex;
  align-items: center;
  gap: 6px;
}

.cltv-dashboard__segment-pill-overflow {
  position: relative;
}

.cltv-dashboard__segment-pill-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #344054;
  font-size: 13px;
  font-weight: 500;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}
.cltv-dashboard__segment-pill-btn:hover {
  background: #f9fafb;
}
.cltv-dashboard__segment-pill-btn.is-active {
  background: #f0f4f8;
  color: #101828;
  font-weight: 600;
}

.cltv-dashboard__pill-caret {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid currentColor;
}

/* Overflow dropdown */
.cltv-dashboard__segment-pill-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 160px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 4px 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
}

.cltv-dashboard__segment-pill-dropdown-item {
  display: block;
  width: 100%;
  padding: 9px 16px;
  text-align: start;
  background: transparent;
  border: 0;
  font-size: 13px;
  font-weight: 500;
  color: #344054;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  white-space: nowrap;
}
.cltv-dashboard__segment-pill-dropdown-item:hover {
  background: #f8fafc;
}
.cltv-dashboard__segment-pill-dropdown-item.is-active {
  color: #2c68ad;
  font-weight: 700;
  background: #f0f6ff;
}

/* Export button */
.cltv-dashboard__export-button {
  box-sizing: border-box;
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: border-color 0.15s, background 0.15s;
}
.cltv-dashboard__export-button:hover {
  border-color: #b0bac8;
  background: #f9fafb;
}

.cltv-dashboard__export-button:disabled {
  border-color: #e2e8f0;
  background: #f9fafb;
  color: #98a2b3;
  cursor: not-allowed;
}

/* Keep full opacity while the spinner is showing — only the "no rows" disabled
   state should look dimmed. */
.cltv-dashboard__export-button--loading:disabled {
  opacity: 1;
  border-color: #d0d5dd;
  background: #fff;
  color: #344054;
}

.cltv-dashboard__export-loader {
  flex-shrink: 0;
}

.cltv-dashboard__customer-analytics .cltv-dashboard__error-banner {
  margin: 0 24px 12px;
}

/* Table scroll wrapper */
.cltv-dashboard__table-wrap {
  overflow-x: auto;
  margin: 0;
  border-top: 1px solid #f2f4f7;
}

/* Table */
.cltv-dashboard__customer-table {
  width: 100%;
  min-width: 1080px;
  table-layout: auto;
  border-collapse: collapse;
}

/* th — aligned to the reading direction, uppercase muted gray, override shared number class */
.cltv-dashboard__customer-table th,
.cltv-dashboard__customer-table th.dashboard-data-table__number {
  text-align: start !important;
  white-space: nowrap;
  vertical-align: middle;
}

/* The shared (?) help row right-aligns itself inside numeric headers via flex,
   which \`text-align\` above cannot undo — keep it left-aligned here too. */
.cltv-dashboard__customer-table thead th.dashboard-data-table__number .dashboard-data-table__th-help-row {
  width: auto;
  justify-content: flex-start;
}

.cltv-dashboard__customer-table.dashboard-data-table th,
.cltv-dashboard__customer-table th {
  color: #667085;
  padding: 14px 16px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  background: #fff;
  border-bottom: 1px solid #f2f4f7;
}

/* td — aligned to the reading direction by default */
.cltv-dashboard__customer-table td {
  text-align: start;
  white-space: nowrap;
  vertical-align: middle;
}

.cltv-dashboard__customer-table.dashboard-data-table td {
  color: #101828;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.4;
  border-bottom: 1px solid #f2f4f7;
}

/* Column widths */
.cltv-dashboard__customer-table th:nth-child(1),
.cltv-dashboard__customer-table td:nth-child(1) {
  min-width: 120px;
  width: 120px;
}

.cltv-dashboard__customer-table th:nth-child(2),
.cltv-dashboard__customer-table td:nth-child(2) {
  min-width: 180px;
  width: 180px;
}

.cltv-dashboard__customer-table th:nth-child(3),
.cltv-dashboard__customer-table td:nth-child(3) {
  min-width: 145px;
  width: 145px;
}

.cltv-dashboard__customer-table th:nth-child(4),
.cltv-dashboard__customer-table td:nth-child(4) {
  min-width: 90px;
  width: 90px;
}

.cltv-dashboard__customer-table th:nth-child(5),
.cltv-dashboard__customer-table td:nth-child(5) {
  min-width: 95px;
  width: 95px;
}

.cltv-dashboard__customer-table th:nth-child(6),
.cltv-dashboard__customer-table td:nth-child(6) {
  min-width: 120px;
  width: 120px;
}

.cltv-dashboard__customer-table th:nth-child(7),
.cltv-dashboard__customer-table td:nth-child(7) {
  min-width: 110px;
  width: 110px;
}

.cltv-dashboard__customer-table th:nth-child(8),
.cltv-dashboard__customer-table td:nth-child(8) {
  min-width: 100px;
  width: 100px;
}

.cltv-dashboard__customer-table th:nth-child(9),
.cltv-dashboard__customer-table td:nth-child(9) {
  min-width: 230px;
}

/* Row hover */
.cltv-dashboard__customer-table tbody tr:hover td {
  background: #fafbfc;
}

/* Customer name — bold dark, not a link */
.cltv-dashboard__customer-name {
  font-weight: 600;
  color: #101828;
  font-size: 13px;
}

/* Email — muted */
.cltv-dashboard__email {
  color: #667085;
  font-weight: 400;
  font-size: 13px;
}

/* Numeric data cells — left-aligned per screenshot */
.cltv-dashboard__numeric {
  font-weight: 400;
  color: #101828;
  font-size: 13px;
  text-align: start !important;
}

/* Predicted CLTV */
.cltv-dashboard__value-emphasis {
  color: #101828;
  font-weight: 400;
}

/* Profile cell */
.cltv-dashboard__profile-cell {
  display: flex;
  flex-direction: column;
  gap: 1px;
  white-space: normal;
}

.cltv-dashboard__profile-cell strong {
  color: #101828;
  font-size: 13px;
  font-weight: 700;
  display: block;
}

.cltv-dashboard__profile-subtext {
  color: #98a2b3;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.5;
  display: block;
  white-space: normal;
}

.cltv-dashboard__profile-meter {
  display: none;
}

/* Segment badges container */
.cltv-dashboard__segment-badges {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 5px;
  align-items: center;
}

/* Segment pill — rounded rectangle */
.cltv-dashboard__segment-pill {
  display: inline-flex;
  align-items: center;
  height: 24px;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cltv-dashboard__segment-pill--loyal {
  color: #fff;
  background: #6366f1;
}

.cltv-dashboard__segment-pill--high-spender {
  color: #fff;
  background: #10b981;
}

.cltv-dashboard__segment-pill--likely-to-churn {
  color: #fff;
  background: #ef4444;
}

.cltv-dashboard__segment-pill--one-timer {
  color: #fff;
  background: #f59e0b;
}

.cltv-dashboard__segment-pill--idle {
  color: #fff;
  background: #6b7280;
}

.cltv-dashboard__segment-pill--indecisive {
  color: #fff;
  background: #8b5cf6;
}

.cltv-dashboard__segment-pill--cart-abandoner {
  color: #fff;
  background: #f97316;
}

.cltv-dashboard__segment-pill--unsubscribed {
  color: #fff;
  background: #64748b;
}

/* +N circular overflow badge */
.cltv-dashboard__segment-pill--overflow {
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 50%;
  background: #344054;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0;
  text-transform: none;
}

/* Pagination footer */
.cltv-dashboard__table-pagination {
  margin: 0;
  padding: 0;
  background: transparent;
  border-top: none;
}

.cltv-dashboard__table-pagination .table-page-pagination {
  width: 100%;
  padding: 14px 24px;
  border-top: 1px solid #f2f4f7;
  min-height: 0;
}

.cltv-dashboard__footer-legend {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.cltv-dashboard__footer-label {
  color: #98a2b3;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cltv-dashboard__footer-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #667085;
  font-size: 12px;
  font-weight: 600;
}

.cltv-dashboard__footer-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.cltv-dashboard__footer-dot--loyal {
  background: #8b5cf6;
}

.cltv-dashboard__footer-dot--high-spender {
  background: #10b981;
}

.cltv-dashboard__footer-dot--likely-to-churn {
  background: #ef4444;
}

.cltv-dashboard__footer-dot--idle {
  background: #2563eb;
}

.cltv-dashboard__footer-dot--unsubscribed {
  background: #475467;
}

.cltv-dashboard__footer-dot--one-timer {
  background: #f59e0b;
}

.cltv-dashboard__footer-dot--indecisive {
  background: #ec4899;
}

.cltv-dashboard__footer-dot--cart-abandoner {
  background: #f97316;
}

.cltv-dashboard__spending-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
  color: #587194;
  font-size: 12px;
  font-weight: 500;
}

.cltv-dashboard__spending-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.cltv-dashboard__spending-legend i {
  display: inline-block;
  width: 24px;
  height: 0;
  border-top: 2px solid transparent;
}

.cltv-dashboard__spending-legend i.is-predicted {
  border-top-color: #3b82f6;
  border-top-style: dashed;
}

.cltv-dashboard__spending-legend i.is-actual {
  border-top-color: #101828;
  border-top-width: 2.5px;
}

.cltv-dashboard__chart-tooltip {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #1a1a1a;
  padding: 8px 10px;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.cltv-dashboard .analytics-chart-tooltip {
  display: flex;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  border: 1px solid #e5e7eb;
  overflow: visible;
  padding: 0;
}

.cltv-dashboard .analytics-chart-tooltip__bar {
  width: 4px;
  background: #2b74e4;
  flex-shrink: 0;
  border-start-start-radius: 8px;
  border-end-start-radius: 8px;
}

.cltv-dashboard .analytics-chart-tooltip__content {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cltv-dashboard .analytics-chart-tooltip__header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cltv-dashboard .analytics-chart-tooltip__header strong {
  font-size: 14px;
  color: #1a1a1a;
}

.cltv-dashboard .analytics-chart-tooltip__pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f2f4f7;
  color: #587194;
  font-size: 12px;
  font-weight: 500;
}

.cltv-dashboard .analytics-chart-tooltip__label {
  font-size: 12px;
  color: #6b7280;
}

.cltv-dashboard .analytics-chart-tooltip__name {
  color: #03045e;
  font-weight: 700;
}

.cltv-dashboard .analytics-chart-tooltip__row-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.cltv-dashboard .analytics-chart-tooltip__row-label i {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  display: inline-block;
  flex-shrink: 0;
}

.cltv-dashboard .analytics-chart-tooltip__value {
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  /* Keeps each figure on the same line as its own label — wrapping put the
     number under the label and made the box taller and ragged. The box is
     shrink-to-fit, so this sets the tooltip's width from its longest row. */
  white-space: nowrap;
}

.cltv-dashboard .analytics-chart-tooltip__header strong,
.cltv-dashboard .analytics-chart-tooltip__label {
  white-space: nowrap;
}

.cltv-dashboard .recharts-tooltip-wrapper {
  z-index: 20;
}

.cltv-dashboard .recharts-default-tooltip {
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
}

@media (max-width: 1360px) {
  .cltv-dashboard__kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .cltv-dashboard__dual {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 1212px) {
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-toolbar {
    min-width: 0;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-toolbar-left {
    flex: 0 1 auto;
    min-width: 0;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-controls {
    flex: 1 1 auto;
    min-width: 0;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-search {
    flex: 1 1 140px;
    min-width: 0;
    width: auto;
    max-width: 300px;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-search input {
    width: 100%;
    min-width: 0;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-controls .filter-dropdown {
    flex: 1 1 120px;
    min-width: 0 !important;
    width: auto !important;
    max-width: 320px;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-controls .filter-dropdown .ant-select-selector {
    width: 100% !important;
    min-width: 0 !important;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__export-button {
    flex-shrink: 0;
  }
}
@media (max-width: 1024px) {
  .cltv-dashboard__top.dashboard-section-header .dashboard-section-header__actions {
    margin-inline-start: auto;
    width: 100%;
    justify-content: flex-end;
  }
  .cltv-dashboard__top.dashboard-section-header .dashboard-section-header__actions--filters {
    grid-template-columns: max-content;
    justify-content: end;
    justify-items: end;
  }
  .cltv-dashboard__top.dashboard-section-header .dashboard-section-header__control,
  .cltv-dashboard__top.dashboard-section-header .dashboard-section-header__control--wide {
    min-width: 0;
    width: auto;
    max-width: 100%;
    margin-inline-start: auto;
  }
}
@media (max-width: 900px) {
  .cltv-dashboard__top {
    flex-direction: column;
  }
  .cltv-dashboard__date-range {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .cltv-dashboard__kpi-grid {
    grid-template-columns: 1fr;
  }
  .cltv-dashboard__customer-analytics {
    margin-left: 12px;
    margin-right: 12px;
  }
  .cltv-dashboard__table-head {
    flex-direction: column;
    align-items: flex-start;
  }
  .cltv-dashboard__table-head-right {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-toolbar {
    flex-direction: column;
    align-items: stretch;
    flex-wrap: wrap;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-toolbar-left {
    width: 100%;
    flex-shrink: 0;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-controls {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-search {
    flex: 1 1 160px;
    width: auto;
    min-width: 0;
    max-width: none;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-search input {
    min-width: 0;
    width: 100%;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-controls .filter-dropdown {
    flex: 1 1 140px;
    min-width: 0 !important;
    width: auto !important;
    max-width: none;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-controls .filter-dropdown .ant-select-selector {
    width: 100% !important;
    min-width: 0 !important;
  }
  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__export-button {
    margin-inline-start: auto;
    flex: 0 0 auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/cltv/components/Tabs/CLTVDashboard.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,cAAA;EACA,cCGa;EDFb,oCAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;AAAF;;AAGA;;EAEE,oCAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;AAEE;EACE,oBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;AADF;;AAIA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;AADF;;AAIA;EACE,gBAAA;EACA,kBAAA;EACA,mBCgJU;ED/IV,yCAAA;EACA,mCAAA;EACA,cC/CU;EDgDV,eCmJa;ADpJf;;AAIA;EACE,cAAA;EACA,cCrDU;EDsDV,eC6Ia;AD9If;;AAIA;;EAEE,yBAAA;EACA,mBCgIU;ED/HV,mBCtEM;EDuEN,oDAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,mCAAA;EACA,cCjIc;EDkId,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;AADF;AAGE;EACE,YAAA;EACA,gBAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,UAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBCwBiB;AD1BnB;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,aAAA;AAFF;;AAKA;;;;;EAKE,iBAAA;AAFF;;AAMA;EACE,eAAA;EACA,cAAA;EACA,aAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;AAHF;;AAMA;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,SAAA;AAHF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAJF;;AAOA;EACE,YAAA;EACA,kBAAA;EACA,2BAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;EACA,gCAAA;AALF;;AAQA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cCnSe;AD8RjB;;AAQA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cC3Sa;ED4Sb,iBAAA;AALF;;AAQA;EACE,SAAA;EACA,eC1Ga;ED2Gb,cCjTe;AD4SjB;;AASA;EACE,iBAAA;EACA,oBAAA;AANF;;AASA;EACE,gBAAA;EACA,eCrHa;EDsHb,gBAAA;EACA,cC/Ta;ADyTf;;AASA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AANF;;AASA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AANF;;AASA;EACE,eCzIa;ED0Ib,cChVe;AD0UjB;;AASA;EACE,eAAA;EACA,gBAAA;EACA,cCvVa;ADiVf;;AAUA;EACE,eAAA;EACA,WAAA;AAPF;;AAWA;EACE,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,wCAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AARF;;AAWA;EACE,SAAA;EACA,eClLa;EDmLb,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AARF;;AAWA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eC9La;ED+Lb,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AARF;;AAWA;EACE,eAAA;EACA,0BAAA;EACA,eCxMa;EDyMb,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,SAAA;EACA,0BAAA;EACA,eCjNa;EDkNb,cAAA;EACA,gBAAA;AARF;;AAWA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;AARF;;AAWA;EACE,aAAA;EACA,SAAA;AARF;;AAWA;EACE,eAAA;EACA,eClOa;AD0Nf;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,eAAA;EACA,eCnPa;EDoPb,gBAAA;EACA,cC9ba;ADsbf;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,SAAA;EACA,eCtQa;EDuQb,cC7ce;ADqcjB;;AAWA;EACE,eAAA;AARF;;AAWA;EACE,cAAA;EACA,eC9Qa;ADsQf;;AAWA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eCzRa;ED0Rb,cCjfc;EDkfd,oCAAA;AARF;;AAWA;EACE,gBAAA;EACA,YAAA;EACA,mBCxSU;EDySV,mBCpdS;EDqdT,gBAAA;AARF;;AAWA;EACE,cAAA;EACA,YAAA;EACA,mBChTU;EDiTV,mBAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AARF;;AAWA;;EAEE,iBAAA;AARF;;AAWA;;;;EAAA;AAKA;;EAEE,cAAA;AARF;;AAWA;;EAEE,cAAA;AARF;;AAWA;EAIE,eAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,oBAAA;EAEA,aAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAZF;;AAeA;EACE,cAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAZF;;AAeA;EACE,mBAAA;EACA,iBAAA;AAZF;;AAeA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AAZF;;AAeA;;EAEE,mBAAA;AAZF;;AAeA;EACE,eAAA;AAZF;;AAeA;EACE,aAAA;EACA,eAAA;EACA,oCAAA;AAZF;;AAeA;EACE,iBAAA;AAZF;;AAeA;EACE,mBAAA;EACA,iBAAA;AAZF;;AAeA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAZF;;AAeA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAZF;;AAeA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AAZF;;AAeA,2EAAA;AAEA;EACE,UAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,SAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAbF;;AAgBA,sDAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAbF;;AAgBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,gBAAA;AAbF;AAeE;EACE,gBAAA;EACA,oBAAA;AAbJ;AAoBI;EACE,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,6BAAA;EACA,iCAAA;EACA,wBAAA;EACA,8BAAA;AAlBN;AAqBI;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,uBAAA;EACA,QAAA;EACA,oBAAA;AAnBN;AAsBI;EACE,yBAAA;EACA,6BAAA;EACA,oBAAA;AApBN;AAuBI;EACE,oBAAA;EACA,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,8BAAA;AArBN;AAwBI;EACE,mBAAA;EACA,sCAAA;EACA,aAAA;AAtBN;;AA2BA,iBAAA;AACA;EACE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AAxBF;AA0BE;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;AAxBJ;AA0BI;EAAiB,cAAA;AAvBrB;;AA2BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAxBF;AA0BE;EACE,cAAA;AAxBJ;;AA4BA,kFAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAzBF;;AA4BA;EACE,kBAAA;AAzBF;;AA4BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,yCAAA;AAzBF;AA2BE;EAAU,mBAAA;AAxBZ;AA0BE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAxBJ;;AA4BA;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;AAzBF;;AA4BA,sBAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;AAzBF;AA2BE;EAAU,mBAAA;AAxBZ;AAyBE;EAAc,cAAA;EAAgB,gBAAA;EAAkB,mBAAA;AApBlD;;AAuBA,kBAAA;AACA;EACE,sBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gDAAA;AApBF;AAsBE;EAAU,qBAAA;EAAuB,mBAAA;AAlBnC;;AAqBA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAlBF;;AAqBA;8BAAA;AAEA;EACE,UAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA,yBAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,6BAAA;AAlBF;;AAqBA,UAAA;AACA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAlBF;;AAqBA,8FAAA;AACA;;EAEE,4BAAA;EACA,mBAAA;EACA,sBAAA;AAlBF;;AAqBA;0EAAA;AAEA;EACE,WAAA;EACA,2BAAA;AAlBF;;AAqBA;;EAEE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gCAAA;AAlBF;;AAqBA,qDAAA;AACA;EACE,iBAAA;EACA,mBAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAlBF;;AAqBA,kBAAA;AACA;;EACkD,gBAAA;EAAkB,YAAA;AAhBpE;;AAkBA;;EACkD,gBAAA;EAAkB,YAAA;AAbpE;;AAeA;;EACkD,gBAAA;EAAkB,YAAA;AAVpE;;AAYA;;EACkD,eAAA;EAAiB,WAAA;AAPnE;;AASA;;EACkD,eAAA;EAAiB,WAAA;AAJnE;;AAMA;;EACkD,gBAAA;EAAkB,YAAA;AADpE;;AAGA;;EACkD,gBAAA;EAAkB,YAAA;AAEpE;;AAAA;;EACkD,gBAAA;EAAkB,YAAA;AAKpE;;AAHA;;EACkD,gBAAA;AAOlD;;AALA,cAAA;AACA;EACE,mBAAA;AAQF;;AALA,0CAAA;AACA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAQF;;AALA,kBAAA;AACA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAQF;;AALA,qDAAA;AACA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;AAQF;;AALA,mBAAA;AACA;EACE,cAAA;EACA,gBAAA;AAQF;;AALA,iBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAQF;;AALA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAQF;;AALA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAQF;;AALA;EACE,aAAA;AAQF;;AALA,6BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,mBAAA;AAQF;;AALA,qCAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AAQF;;AALA;EACE,WAAA;EACA,mBAAA;AAQF;;AALA;EACE,WAAA;EACA,mBAAA;AAQF;;AALA;EACE,WAAA;EACA,mBAAA;AAQF;;AALA;EACE,WAAA;EACA,mBAAA;AAQF;;AALA;EACE,WAAA;EACA,mBAAA;AAQF;;AALA;EACE,WAAA;EACA,mBAAA;AAQF;;AALA;EACE,WAAA;EACA,mBAAA;AAQF;;AALA;EACE,WAAA;EACA,mBAAA;AAQF;;AALA,+BAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AAQF;;AALA,sBAAA;AACA;EACE,SAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;AAQF;;AALA;EACE,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;AAQF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAQF;;AALA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAQF;;AALA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAQF;;AALA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAQF;;AALA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAQF;;AALA;EACE,qBAAA;EACA,WAAA;EACA,SAAA;EACA,iCAAA;AAQF;;AALA;EACE,yBAAA;EACA,wBAAA;AAQF;;AALA;EACE,yBAAA;EACA,uBAAA;AAQF;;AALA;EACE,mBC9vCM;ED+vCN,yBAAA;EACA,kBC5jCU;ED6jCV,cC5vCa;ED6vCb,iBAAA;EACA,eCtjCa;EDujCb,yCCplCU;AD4lCZ;;AALA;EACE,aAAA;EACA,mBCzwCM;ED0wCN,kBCtkCU;EDukCV,yCC1lCU;ED2lCV,yBAAA;EAKA,iBAAA;EACA,UAAA;AAIF;;AADA;EACE,UAAA;EACA,mBAAA;EACA,cAAA;EACA,8BCrlCU;EDslCV,4BCtlCU;AD0lCZ;;AADA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAIF;;AADA;EACE,eAAA;EACA,cCvyCa;AD2yCf;;AADA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAIF;;AADA;EACE,eC/mCa;EDgnCb,cCtzCe;AD0zCjB;;AADA;EACE,cCt0CS;EDu0CT,gBC/mCiB;ADmnCnB;;AADA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAIF;;AADA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,cAAA;AAIF;;AADA;EACE,eCtoCa;EDuoCb,gBAAA;EACA,cCh1Ca;EDi1Cb;;4EAAA;EAGA,mBAAA;AAIF;;AADA;;EAEE,mBAAA;AAIF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,qBAAA;EACA,kCAAA;EACA,uBAAA;AAIF;;AADA;EACE;IACE,gDAAA;EAIF;EADA;IACE,0BAAA;EAGF;AACF;AAAA;EACE;IACE,YAAA;EAEF;EACA;IACE,cAAA;IACA,YAAA;EACF;EAEA;IACE,cAAA;IACA,YAAA;EAAF;EAGA;IACE,eAAA;IACA,YAAA;IACA,WAAA;IACA,gBAAA;EADF;EAGE;IACE,WAAA;IACA,YAAA;EADJ;EAKA;IACE,eAAA;IACA,uBAAA;IACA,sBAAA;IACA,gBAAA;EAHF;EAKE;IACE,sBAAA;IACA,uBAAA;EAHJ;EAOA;IACE,cAAA;EALF;AACF;AAQA;EACE;IACE,yBAAA;IACA,WAAA;IACA,yBAAA;EANF;EASA;IACE,kCAAA;IACA,oBAAA;IACA,kBAAA;EAPF;EAUA;;IAEE,YAAA;IACA,WAAA;IACA,eAAA;IACA,yBAAA;EARF;AACF;AAWA;EACE;IACE,sBAAA;EATF;EAYA;IACE,WAAA;IACA,2BAAA;IACA,eAAA;EAVF;EAaA;IACE,0BAAA;EAXF;EAcA;IACE,iBAAA;IACA,kBAAA;EAZF;EAeA;IACE,sBAAA;IACA,uBAAA;EAbF;EAgBA;IACE,WAAA;IACA,8BAAA;IACA,eAAA;EAdF;EAiBA;IACE,sBAAA;IACA,oBAAA;IACA,eAAA;EAfF;EAkBA;IACE,WAAA;IACA,cAAA;EAhBF;EAmBA;IACE,WAAA;IACA,eAAA;IACA,2BAAA;EAjBF;EAoBA;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;EAlBF;EAoBE;IACE,YAAA;IACA,WAAA;EAlBJ;EAsBA;IACE,eAAA;IACA,uBAAA;IACA,sBAAA;IACA,eAAA;EApBF;EAsBE;IACE,sBAAA;IACA,uBAAA;EApBJ;EAwBA;IACE,yBAAA;IACA,cAAA;EAtBF;AACF","sourcesContent":["@import \"../../../../styles/variables\";\n\n.cltv-dashboard-layout {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.cltv-dashboard {\n  width: 100%;\n  margin: 0 auto;\n  color: $text-primary;\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.cltv-dashboard__main {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: visible;\n  -webkit-overflow-scrolling: touch;\n}\n\n.cltv-dashboard input,\n.cltv-dashboard button {\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.cltv-dashboard button {\n  text-transform: uppercase;\n}\n\n.cltv-dashboard__top {\n  flex-shrink: 0;\n  margin-bottom: 8px;\n}\n\n.cltv-dashboard__main .dashboard-narrative-panel {\n  margin-bottom: 14px;\n\n  button {\n    text-transform: none;\n  }\n}\n\n.cltv-dashboard__kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.cltv-dashboard__kpi-loading {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: center;\n  padding: 24px;\n}\n\n.cltv-dashboard__error-banner {\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  border-radius: $radius-lg;\n  border: 1px solid rgba(180, 60, 60, 0.35);\n  background: rgba(180, 60, 60, 0.08);\n  color: $text-dark;\n  font-size: $font-size-sm;\n}\n\n.cltv-dashboard__empty {\n  margin: 16px 0;\n  color: $text-dark;\n  font-size: $font-size-sm;\n}\n\n.cltv-dashboard__kpi-card,\n.cltv-dashboard__panel {\n  border: 1px solid #e2e8f0;\n  border-radius: $radius-lg;\n  background: $white;\n  box-shadow: $shadow-sm !important;\n}\n\n.cltv-dashboard__kpi-card {\n  padding: 18px 20px;\n}\n\n.cltv-dashboard__kpi-card .dashboard-kpi-card__title {\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  max-height: none;\n  -webkit-line-clamp: unset;\n  line-clamp: unset;\n}\n\n.cltv-dashboard__kpi-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  min-width: 0;\n}\n\n.cltv-dashboard__kpi-title-text {\n  color: #667085;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.35;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  flex: 0 1 auto;\n}\n\n.cltv-dashboard__badge {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 18px;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  background: rgba(44, 104, 173, 0.18);\n  border: 1px solid rgba(44, 104, 173, 1);\n  color: $brand-primary;\n  display: inline-flex;\n  align-items: center;\n  align-self: center;\n  white-space: nowrap;\n  line-height: 1.2;\n}\n\n.cltv-dashboard__kpi-card .dashboard-kpi-card__description {\n  margin-top: 0;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.cltv-dashboard__kpi-card .dashboard-kpi-card__footer {\n  margin-top: -4px;\n}\n\n.cltv-dashboard__kpi-card strong {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n}\n\n.cltv-dashboard__trend-up {\n  color: #0f9f60;\n}\n\n.cltv-dashboard__trend-down {\n  color: #d92d20;\n}\n\n.cltv-dashboard__dual {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-bottom: 14px;\n  align-items: stretch;\n\n  > article {\n    height: 100%;\n    margin-bottom: 0;\n  }\n}\n\n.cltv-dashboard__panel {\n  padding: 18px;\n  margin-bottom: 14px;\n  overflow: visible;\n}\n\n.cltv-dashboard__panel--segment-distribution {\n  display: flex;\n  flex-direction: column;\n}\n\n.cltv-dashboard__panel--customer-analytics {\n  padding: 0;\n  overflow: hidden;\n}\n\n.cltv-dashboard__panel h3 {\n  margin: 0 0 14px;\n  color: #101828;\n  font-size: 18px;\n  font-weight: $font-weight-bold;\n}\n\n.cltv-dashboard__title-with-tooltip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 14px;\n}\n\n.cltv-dashboard__title-with-tooltip .definition-tooltip {\n  flex-shrink: 0;\n}\n\n.cltv-dashboard__title-with-tooltip h3 {\n  margin-bottom: 0;\n}\n\n.cltv-dashboard__title-with-tooltip--table {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.cltv-dashboard__kpi-card,\n.cltv-dashboard__kpi-card .dashboard-kpi-card,\n.cltv-dashboard__kpi-card .dashboard-kpi-card__header,\n.cltv-dashboard__kpi-card .dashboard-kpi-card__header-main,\n.cltv-dashboard__kpi-card .dashboard-kpi-card__title-row {\n  overflow: visible;\n}\n\n\n.cltv-dashboard__segment-chart-wrap {\n  margin-top: 8px;\n  flex: 1 1 auto;\n  display: flex;\n}\n\n.cltv-dashboard__hbar-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  flex: 1 1 auto;\n  padding: 15px;\n}\n\n.cltv-dashboard__hbar-row {\n  display: grid;\n  grid-template-columns: 110px 1fr 56px;\n  align-items: center;\n  gap: 10px;\n}\n\n// unused after TSX refactor — kept for safety\n.cltv-dashboard__hbar-row-head {\n  display: contents;\n}\n\n.cltv-dashboard__hbar-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #344054;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cltv-dashboard__hbar-track {\n  width: 100%;\n  height: 18px;\n  background: #f1f4f8;\n  border-radius: 4px;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.cltv-dashboard__hbar-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.4s ease;\n}\n\n.cltv-dashboard__hbar-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: #344054;\n  text-align: end;\n  white-space: nowrap;\n}\n\n.cltv-dashboard__insights {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n// Predictive Insights — revenue block\n.cltv-dashboard__pi-revenue {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid $gray-200;\n}\n\n.cltv-dashboard__pi-revenue-label {\n  margin: 0;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: $text-secondary;\n}\n\n.cltv-dashboard__pi-revenue-value {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 700;\n  color: $text-primary;\n  line-height: 1.15;\n}\n\n.cltv-dashboard__pi-revenue-desc {\n  margin: 0;\n  font-size: $font-size-sm;\n  color: $text-secondary;\n}\n\n// Predictive Insights — risk tier block\n.cltv-dashboard__pi-risk {\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n\n.cltv-dashboard__pi-risk-title {\n  margin: 0 0 10px;\n  font-size: $font-size-md;\n  font-weight: 600;\n  color: $text-primary;\n}\n\n.cltv-dashboard__pi-tiers {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cltv-dashboard__pi-tier-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.cltv-dashboard__pi-tier-name {\n  font-size: $font-size-sm;\n  color: $text-secondary;\n}\n\n.cltv-dashboard__pi-tier-count {\n  font-size: 13px;\n  font-weight: 700;\n  color: $text-primary;\n}\n\n// Risk tier bars — thinner + full-width track\n.cltv-dashboard__pi-tier .cltv-dashboard__progress {\n  margin-top: 4px;\n  height: 6px;\n}\n\n// Predictive Insights — churn alert block\n.cltv-dashboard__pi-churn-alert {\n  padding: 12px 14px;\n  border-radius: 8px;\n  background: rgba(224, 82, 82, 0.08);\n  border: 1px solid rgba(224, 82, 82, 0.2);\n}\n\n.cltv-dashboard__pi-churn-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.cltv-dashboard__pi-churn-icon {\n  display: flex;\n  align-items: center;\n  color: #e05252;\n  flex-shrink: 0;\n}\n\n.cltv-dashboard__pi-churn-label {\n  flex: 1;\n  font-size: $font-size-sm;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #e05252;\n}\n\n.cltv-dashboard__pi-churn-badge {\n  padding: 4px 12px;\n  border-radius: 4px;\n  background: #e05252;\n  font-size: $font-size-xs;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #fff;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.cltv-dashboard__pi-churn-count {\n  margin: 0 0 4px;\n  padding-inline-start: 24px; // icon(16px) + gap(8px) — aligns under the label text\n  font-size: $font-size-md;\n  font-weight: 700;\n  color: #e05252;\n}\n\n.cltv-dashboard__pi-churn-desc {\n  margin: 0;\n  padding-inline-start: 24px; // icon(16px) + gap(8px) — aligns under the label text\n  font-size: $font-size-sm;\n  color: #e05252;\n  line-height: 1.5;\n}\n\n.cltv-dashboard__insight-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.cltv-dashboard__insight-left {\n  display: flex;\n  gap: 10px;\n}\n\n.cltv-dashboard__insight-icon {\n  margin-top: 4px;\n  font-size: $font-size-lg;\n}\n\n.cltv-dashboard__insight-icon--positive {\n  color: #94d0b5;\n}\n\n.cltv-dashboard__insight-icon--warning {\n  color: #f6c15f;\n}\n\n.cltv-dashboard__insight-icon--info {\n  color: #8d4fd3;\n}\n\n.cltv-dashboard__insight-left h4 {\n  margin: 0 0 4px;\n  font-size: $font-size-lg;\n  font-weight: 600;\n  color: $text-primary;\n}\n\n.cltv-dashboard__insight-title-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.cltv-dashboard__insight-title-row h4 {\n  margin-bottom: 0;\n}\n\n.cltv-dashboard__insight-left p {\n  margin: 0;\n  font-size: $font-size-sm;\n  color: $text-secondary;\n}\n\n.cltv-dashboard__insight-right {\n  text-align: end;\n}\n\n.cltv-dashboard__insight-right strong {\n  display: block;\n  font-size: $font-size-lg;\n}\n\n.cltv-dashboard__insight-right span {\n  display: inline-block;\n  margin-top: 6px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  border: 1px solid rgba(44, 104, 173, 1);\n  font-size: $font-size-sm;\n  color: $brand-primary;\n  background: rgba(44, 104, 173, 0.18);\n}\n\n.cltv-dashboard__progress {\n  margin-top: 10px;\n  height: 10px;\n  border-radius: $radius-lg;\n  background: $gray-200;\n  overflow: hidden;\n}\n\n.cltv-dashboard__progress span {\n  display: block;\n  height: 100%;\n  border-radius: $radius-lg;\n  background: #2b74e4;\n}\n\n.cltv-dashboard__chart {\n  width: 100%;\n  height: auto;\n  position: relative;\n  overflow: visible;\n}\n\n.cltv-dashboard__chart .recharts-wrapper,\n.cltv-dashboard__chart .recharts-surface {\n  overflow: visible;\n}\n\n/**\n * Segment Evolution + Actual vs Predicted Revenue: Recharts positions hover coordinates\n * in an LTR system. In Arabic the wrapper inherits `dir=\"rtl\"`, which skews\n * `activeCoordinate` and sends the portalled tooltip to the viewport's far edge.\n */\n.cltv-dashboard__panel--spending .cltv-dashboard__chart .recharts-wrapper,\n.cltv-dashboard__panel--evolution .cltv-dashboard__chart .recharts-wrapper {\n  direction: ltr;\n}\n\n.cltv-dashboard__panel--spending .cltv-dashboard__chart .recharts-surface,\n.cltv-dashboard__panel--evolution .cltv-dashboard__chart .recharts-surface {\n  direction: ltr;\n}\n\n.cltv-dashboard__floating-tooltip {\n  // `fixed` + viewport-space left/top (set in JS via getBoundingClientRect, see\n  // FloatingTooltip in CLTVDashboard.tsx) so the box clamps against the actual\n  // screen edges instead of an ancestor that may be wider than what's visible.\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: max-content;\n  max-width: min(420px, calc(100vw - 16px));\n  visibility: hidden;\n  pointer-events: none;\n  // Body-level once portalled, so it shares DefinitionTooltip's layer.\n  z-index: 5000;\n}\n\n.cltv-dashboard__floating-tooltip--placed {\n  visibility: visible;\n}\n\n.cltv-dashboard__floating-tooltip--chart-panel {\n  direction: ltr;\n}\n\n[dir=\"rtl\"] .cltv-dashboard__floating-tooltip--chart-panel .analytics-chart-tooltip {\n  direction: rtl;\n}\n\n[dir=\"rtl\"] .cltv-dashboard__floating-tooltip--spending-panel {\n  direction: ltr;\n}\n\n[dir=\"rtl\"] .cltv-dashboard__floating-tooltip--spending-panel .analytics-chart-tooltip {\n  direction: rtl;\n}\n\n.cltv-dashboard__chart-subtitle {\n  flex: 0 0 100%;\n  margin: 2px 0 0;\n  color: #587194;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.cltv-dashboard__panel-note {\n  flex: 0 0 100%;\n  padding: 0;\n  border-radius: 6px;\n  color: #587194;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.cltv-dashboard__panel--spending {\n  padding-bottom: 8px;\n  overflow: visible;\n}\n\n.cltv-dashboard__spending-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-bottom: 4px;\n}\n\n.cltv-dashboard .recharts-cartesian-axis-line,\n.cltv-dashboard .recharts-cartesian-axis-tick-line {\n  stroke: transparent;\n}\n\n.cltv-dashboard .recharts-cartesian-grid line {\n  stroke: #e8eef8;\n}\n\n.cltv-dashboard .recharts-text {\n  fill: #587194;\n  font-size: 12px;\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.cltv-dashboard .recharts-reference-line line {\n  stroke-width: 2px;\n}\n\n.cltv-dashboard__panel--evolution {\n  padding-bottom: 8px;\n  overflow: visible;\n}\n\n.cltv-dashboard__evolution-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 4px;\n}\n\n.cltv-dashboard__line-legend {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  font-size: 12px;\n  font-weight: 500;\n  color: #344054;\n  flex-shrink: 0;\n}\n\n.cltv-dashboard__line-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #344054;\n}\n\n.cltv-dashboard__line-legend i {\n  width: 10px;\n  height: 10px;\n  border-radius: 10%;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n/* ── Customer Analytics Table card ───────────────────────────────────── */\n\n.cltv-dashboard__panel--customer-analytics {\n  padding: 0;\n  overflow: hidden;\n}\n\n.cltv-dashboard__customer-analytics {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n  overflow: visible;\n}\n\n/* Toolbar ── title left, controls right, single row */\n.cltv-dashboard__table-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 16px;\n  padding: 20px 24px;\n}\n\n.cltv-dashboard__table-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.cltv-dashboard__data-table-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #101828;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.cltv-dashboard__table-controls {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 8px;\n  margin-bottom: 0;\n\n  .filter-dropdown {\n    min-width: 180px;\n    margin: 0 !important;\n\n    // Height is actually governed by the higher-specificity\n    // `.filter-dropdown.custom-dropdown .ant-select-selector` rule in\n    // DropDownStyle.scss (42px !important), which wins the cascade tie over\n    // this rule. Kept in sync here so the intent is legible; the search bar\n    // and export button below are pinned to 42px to match the real value.\n    .ant-select-selector {\n      height: 42px !important;\n      width: 320px;\n      min-height: 42px !important;\n      border-radius: 6px !important;\n      padding: 0 40px 0 12px !important;\n      display: flex !important;\n      align-items: center !important;\n    }\n\n    .ant-select-selection-overflow {\n      display: flex !important;\n      flex-wrap: nowrap;\n      overflow: hidden;\n      align-items: center !important;\n      height: 100% !important;\n      gap: 4px;\n      margin: 0 !important;\n    }\n\n    .ant-select-selection-overflow-item {\n      flex: 0 0 auto !important;\n      align-self: center !important;\n      margin: 0 !important;\n    }\n\n    .ant-select-selection-item {\n      margin: 0 !important;\n      height: 28px !important;\n      line-height: 28px !important;\n      border-radius: 4px !important;\n      font-size: 13px !important;\n      flex: 0 0 auto !important;\n      max-width: 120px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      display: inline-flex !important;\n      align-items: center !important;\n    }\n\n    .ant-select-arrow {\n      top: 50% !important;\n      transform: translateY(-50%) !important;\n      margin-top: 0;\n    }\n  }\n}\n\n/* Search input */\n.cltv-dashboard__table-search {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 42px;\n  padding: 0 14px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #fff;\n  cursor: text;\n  color: #98a2b3;\n\n  input {\n    border: 0;\n    outline: none;\n    background: transparent;\n    width: 300px;\n    font-size: 13px;\n    color: #344054;\n    font-family: \"Open Sans\", sans-serif;\n\n    &::placeholder { color: #98a2b3; }\n  }\n}\n\n.cltv-dashboard__table-search-clear {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #667085;\n  cursor: pointer;\n  flex-shrink: 0;\n\n  &:hover {\n    color: #344054;\n  }\n}\n\n/* Segment pill filter buttons — each is a standalone pill, no connected borders */\n.cltv-dashboard__segment-pills {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.cltv-dashboard__segment-pill-overflow {\n  position: relative;\n}\n\n.cltv-dashboard__segment-pill-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #fff;\n  color: #344054;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s, color 0.15s;\n\n  &:hover { background: #f9fafb; }\n\n  &.is-active {\n    background: #f0f4f8;\n    color: #101828;\n    font-weight: 600;\n  }\n}\n\n.cltv-dashboard__pill-caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid currentColor;\n}\n\n/* Overflow dropdown */\n.cltv-dashboard__segment-pill-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  min-width: 160px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  padding: 4px 0;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n}\n\n.cltv-dashboard__segment-pill-dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 9px 16px;\n  text-align: start;\n  background: transparent;\n  border: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #344054;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  white-space: nowrap;\n\n  &:hover { background: #f8fafc; }\n  &.is-active { color: #2c68ad; font-weight: 700; background: #f0f6ff; }\n}\n\n/* Export button */\n.cltv-dashboard__export-button {\n  box-sizing: border-box;\n  height: 42px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 16px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #fff;\n  color: #344054;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: border-color 0.15s, background 0.15s;\n\n  &:hover { border-color: #b0bac8; background: #f9fafb; }\n}\n\n.cltv-dashboard__export-button:disabled {\n  border-color: #e2e8f0;\n  background: #f9fafb;\n  color: #98a2b3;\n  cursor: not-allowed;\n}\n\n/* Keep full opacity while the spinner is showing — only the \"no rows\" disabled\n   state should look dimmed. */\n.cltv-dashboard__export-button--loading:disabled {\n  opacity: 1;\n  border-color: #d0d5dd;\n  background: #fff;\n  color: #344054;\n}\n\n.cltv-dashboard__export-loader {\n  flex-shrink: 0;\n}\n\n.cltv-dashboard__customer-analytics .cltv-dashboard__error-banner {\n  margin: 0 24px 12px;\n}\n\n/* Table scroll wrapper */\n.cltv-dashboard__table-wrap {\n  overflow-x: auto;\n  margin: 0;\n  border-top: 1px solid #f2f4f7;\n}\n\n/* Table */\n.cltv-dashboard__customer-table {\n  width: 100%;\n  min-width: 1080px;\n  table-layout: auto;\n  border-collapse: collapse;\n}\n\n/* th — aligned to the reading direction, uppercase muted gray, override shared number class */\n.cltv-dashboard__customer-table th,\n.cltv-dashboard__customer-table th.dashboard-data-table__number {\n  text-align: start !important;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n/* The shared (?) help row right-aligns itself inside numeric headers via flex,\n   which `text-align` above cannot undo — keep it left-aligned here too. */\n.cltv-dashboard__customer-table thead th.dashboard-data-table__number .dashboard-data-table__th-help-row {\n  width: auto;\n  justify-content: flex-start;\n}\n\n.cltv-dashboard__customer-table.dashboard-data-table th,\n.cltv-dashboard__customer-table th {\n  color: #667085;\n  padding: 14px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  background: #fff;\n  border-bottom: 1px solid #f2f4f7;\n}\n\n/* td — aligned to the reading direction by default */\n.cltv-dashboard__customer-table td {\n  text-align: start;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.cltv-dashboard__customer-table.dashboard-data-table td {\n  color: #101828;\n  padding: 12px 16px;\n  font-size: 13px;\n  line-height: 1.4;\n  border-bottom: 1px solid #f2f4f7;\n}\n\n/* Column widths */\n.cltv-dashboard__customer-table th:nth-child(1),\n.cltv-dashboard__customer-table td:nth-child(1) { min-width: 120px; width: 120px; }\n\n.cltv-dashboard__customer-table th:nth-child(2),\n.cltv-dashboard__customer-table td:nth-child(2) { min-width: 180px; width: 180px; }\n\n.cltv-dashboard__customer-table th:nth-child(3),\n.cltv-dashboard__customer-table td:nth-child(3) { min-width: 145px; width: 145px; }\n\n.cltv-dashboard__customer-table th:nth-child(4),\n.cltv-dashboard__customer-table td:nth-child(4) { min-width: 90px; width: 90px; }\n\n.cltv-dashboard__customer-table th:nth-child(5),\n.cltv-dashboard__customer-table td:nth-child(5) { min-width: 95px; width: 95px; }\n\n.cltv-dashboard__customer-table th:nth-child(6),\n.cltv-dashboard__customer-table td:nth-child(6) { min-width: 120px; width: 120px; }\n\n.cltv-dashboard__customer-table th:nth-child(7),\n.cltv-dashboard__customer-table td:nth-child(7) { min-width: 110px; width: 110px; }\n\n.cltv-dashboard__customer-table th:nth-child(8),\n.cltv-dashboard__customer-table td:nth-child(8) { min-width: 100px; width: 100px; }\n\n.cltv-dashboard__customer-table th:nth-child(9),\n.cltv-dashboard__customer-table td:nth-child(9) { min-width: 230px; }\n\n/* Row hover */\n.cltv-dashboard__customer-table tbody tr:hover td {\n  background: #fafbfc;\n}\n\n/* Customer name — bold dark, not a link */\n.cltv-dashboard__customer-name {\n  font-weight: 600;\n  color: #101828;\n  font-size: 13px;\n}\n\n/* Email — muted */\n.cltv-dashboard__email {\n  color: #667085;\n  font-weight: 400;\n  font-size: 13px;\n}\n\n/* Numeric data cells — left-aligned per screenshot */\n.cltv-dashboard__numeric {\n  font-weight: 400;\n  color: #101828;\n  font-size: 13px;\n  text-align: start !important;\n}\n\n/* Predicted CLTV */\n.cltv-dashboard__value-emphasis {\n  color: #101828;\n  font-weight: 400;\n}\n\n/* Profile cell */\n.cltv-dashboard__profile-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  white-space: normal;\n}\n\n.cltv-dashboard__profile-cell strong {\n  color: #101828;\n  font-size: 13px;\n  font-weight: 700;\n  display: block;\n}\n\n.cltv-dashboard__profile-subtext {\n  color: #98a2b3;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 1.5;\n  display: block;\n  white-space: normal;\n}\n\n.cltv-dashboard__profile-meter {\n  display: none;\n}\n\n/* Segment badges container */\n.cltv-dashboard__segment-badges {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 5px;\n  align-items: center;\n}\n\n/* Segment pill — rounded rectangle */\n.cltv-dashboard__segment-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  border-radius: 6px;\n  padding: 0 10px;\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cltv-dashboard__segment-pill--loyal {\n  color: #fff;\n  background: #6366f1;\n}\n\n.cltv-dashboard__segment-pill--high-spender {\n  color: #fff;\n  background: #10b981;\n}\n\n.cltv-dashboard__segment-pill--likely-to-churn {\n  color: #fff;\n  background: #ef4444;\n}\n\n.cltv-dashboard__segment-pill--one-timer {\n  color: #fff;\n  background: #f59e0b;\n}\n\n.cltv-dashboard__segment-pill--idle {\n  color: #fff;\n  background: #6b7280;\n}\n\n.cltv-dashboard__segment-pill--indecisive {\n  color: #fff;\n  background: #8b5cf6;\n}\n\n.cltv-dashboard__segment-pill--cart-abandoner {\n  color: #fff;\n  background: #f97316;\n}\n\n.cltv-dashboard__segment-pill--unsubscribed {\n  color: #fff;\n  background: #64748b;\n}\n\n/* +N circular overflow badge */\n.cltv-dashboard__segment-pill--overflow {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border-radius: 50%;\n  background: #344054;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n/* Pagination footer */\n.cltv-dashboard__table-pagination {\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  border-top: none;\n}\n\n.cltv-dashboard__table-pagination .table-page-pagination {\n  width: 100%;\n  padding: 14px 24px;\n  border-top: 1px solid #f2f4f7;\n  min-height: 0;\n}\n\n.cltv-dashboard__footer-legend {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.cltv-dashboard__footer-label {\n  color: #98a2b3;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cltv-dashboard__footer-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #667085;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.cltv-dashboard__footer-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.cltv-dashboard__footer-dot--loyal {\n  background: #8b5cf6;\n}\n\n.cltv-dashboard__footer-dot--high-spender {\n  background: #10b981;\n}\n\n.cltv-dashboard__footer-dot--likely-to-churn {\n  background: #ef4444;\n}\n\n.cltv-dashboard__footer-dot--idle {\n  background: #2563eb;\n}\n\n.cltv-dashboard__footer-dot--unsubscribed {\n  background: #475467;\n}\n\n.cltv-dashboard__footer-dot--one-timer {\n  background: #f59e0b;\n}\n\n.cltv-dashboard__footer-dot--indecisive {\n  background: #ec4899;\n}\n\n.cltv-dashboard__footer-dot--cart-abandoner {\n  background: #f97316;\n}\n\n.cltv-dashboard__spending-legend {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  color: #587194;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.cltv-dashboard__spending-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.cltv-dashboard__spending-legend i {\n  display: inline-block;\n  width: 24px;\n  height: 0;\n  border-top: 2px solid transparent;\n}\n\n.cltv-dashboard__spending-legend i.is-predicted {\n  border-top-color: #3b82f6;\n  border-top-style: dashed;\n}\n\n.cltv-dashboard__spending-legend i.is-actual {\n  border-top-color: #101828;\n  border-top-width: 2.5px;\n}\n\n.cltv-dashboard__chart-tooltip {\n  background: $white;\n  border: 1px solid $border-default;\n  border-radius: $radius-md;\n  color: $text-primary;\n  padding: 8px 10px;\n  font-size: $font-size-md;\n  box-shadow: $shadow-sm;\n}\n\n.cltv-dashboard .analytics-chart-tooltip {\n  display: flex;\n  background: $white;\n  border-radius: $radius-md;\n  box-shadow: $shadow-md;\n  border: 1px solid $border-light;\n  // Rounds the corners over `__bar` without ever clipping tooltip text: a\n  // multi-row payload (e.g. six segment rows) can be wider than the box's\n  // planned `max-width`, and hiding the overflow here sliced characters off\n  // instead of letting the box grow to fit its content.\n  overflow: visible;\n  padding: 0;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__bar {\n  width: 4px;\n  background: #2b74e4;\n  flex-shrink: 0;\n  border-start-start-radius: $radius-md;\n  border-end-start-radius: $radius-md;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__content {\n  padding: 8px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__header strong {\n  font-size: 14px;\n  color: $text-primary;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #f2f4f7;\n  color: #587194;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__label {\n  font-size: $font-size-sm;\n  color: $text-secondary;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__name {\n  color: $blue-400;\n  font-weight: $font-weight-bold;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__row-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__row-label i {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__value {\n  font-size: $font-size-md;\n  font-weight: 500;\n  color: $text-primary;\n  /* Keeps each figure on the same line as its own label — wrapping put the\n     number under the label and made the box taller and ragged. The box is\n     shrink-to-fit, so this sets the tooltip's width from its longest row. */\n  white-space: nowrap;\n}\n\n.cltv-dashboard .analytics-chart-tooltip__header strong,\n.cltv-dashboard .analytics-chart-tooltip__label {\n  white-space: nowrap;\n}\n\n.cltv-dashboard .recharts-tooltip-wrapper {\n  z-index: 20;\n}\n\n.cltv-dashboard .recharts-default-tooltip {\n  padding: 0 !important;\n  background: transparent !important;\n  border: none !important;\n}\n\n@media (max-width: 1360px) {\n  .cltv-dashboard__kpi-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .cltv-dashboard__dual {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 1212px) {\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-toolbar {\n    min-width: 0;\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-toolbar-left {\n    flex: 0 1 auto;\n    min-width: 0;\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-controls {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-search {\n    flex: 1 1 140px;\n    min-width: 0;\n    width: auto;\n    max-width: 300px;\n\n    input {\n      width: 100%;\n      min-width: 0;\n    }\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-controls .filter-dropdown {\n    flex: 1 1 120px;\n    min-width: 0 !important;\n    width: auto !important;\n    max-width: 320px;\n\n    .ant-select-selector {\n      width: 100% !important;\n      min-width: 0 !important;\n    }\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__export-button {\n    flex-shrink: 0;\n  }\n}\n\n@media (max-width: 1024px) {\n  .cltv-dashboard__top.dashboard-section-header .dashboard-section-header__actions {\n    margin-inline-start: auto;\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .cltv-dashboard__top.dashboard-section-header .dashboard-section-header__actions--filters {\n    grid-template-columns: max-content;\n    justify-content: end;\n    justify-items: end;\n  }\n\n  .cltv-dashboard__top.dashboard-section-header .dashboard-section-header__control,\n  .cltv-dashboard__top.dashboard-section-header .dashboard-section-header__control--wide {\n    min-width: 0;\n    width: auto;\n    max-width: 100%;\n    margin-inline-start: auto;\n  }\n}\n\n@media (max-width: 900px) {\n  .cltv-dashboard__top {\n    flex-direction: column;\n  }\n\n  .cltv-dashboard__date-range {\n    width: 100%;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .cltv-dashboard__kpi-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .cltv-dashboard__customer-analytics {\n    margin-left: 12px;\n    margin-right: 12px;\n  }\n\n  .cltv-dashboard__table-head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .cltv-dashboard__table-head-right {\n    width: 100%;\n    justify-content: space-between;\n    flex-wrap: wrap;\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-toolbar-left {\n    width: 100%;\n    flex-shrink: 0;\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-controls {\n    width: 100%;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-search {\n    flex: 1 1 160px;\n    width: auto;\n    min-width: 0;\n    max-width: none;\n\n    input {\n      min-width: 0;\n      width: 100%;\n    }\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__table-controls .filter-dropdown {\n    flex: 1 1 140px;\n    min-width: 0 !important;\n    width: auto !important;\n    max-width: none;\n\n    .ant-select-selector {\n      width: 100% !important;\n      min-width: 0 !important;\n    }\n  }\n\n  .cltv-dashboard__panel--customer-analytics .cltv-dashboard__export-button {\n    margin-inline-start: auto;\n    flex: 0 0 auto;\n  }\n}\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
